__webpack_require__.p = "https://dev-assets.rosi-sdlc.silkroad-eng.com/";